import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, } from "recharts";
const COLORS = { withUser: "#009728", withoutUser: "#FAAD14", };

export default function ProjectChart({ data, onProjectClick }) {
  const handleBarClick = (dataEntry) => {
    if (dataEntry && dataEntry.project) {
      onProjectClick(dataEntry.project);
    }
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="project"
          angle={-45}
          textAnchor="end"
          height={100}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <YAxis />
        <Tooltip
          contentStyle={{
            backgroundColor: "white",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
          }}
        />
        <Legend
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{
            marginTop: 10,
            paddingTop: 0,
            marginBottom: -40,
          }}
        />
        <Bar
          dataKey="withUser"
          name="Con Participante"
          fill={COLORS.withUser}
          cursor="pointer"
          stackId="a"
          onClick={(_, index) => handleBarClick(data[index])}
        />
        <Bar
          dataKey="withoutUser"
          name="Sin Participante"
          fill={COLORS.withoutUser}
          cursor="pointer"
          stackId="a"
          onClick={(_, index) => handleBarClick(data[index])}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
